import { t } from '@lingui/core/macro';
import { validPhoneRegex } from 'shared/validators/phone.validator';
import * as yup from 'yup';

// Validator for Organizer form values used in Formik (UI-level shape)
// Notes:
// - Keeps validation minimal and non-blocking: required name and sport type; optional email/phone with format checks.
// - Address and logo are optional and loosely validated to avoid blocking edits before user provides data.
// - Messages are Lingui functions: yup calls them at validation time, in the current language.
export const organizerFormValidator = () =>
  yup
    .object({
      name: yup
        .string()
        .trim()
        .required(() => t`Введите название организации`),
      sportType: yup
        .object({
          label: yup.string().required(),
          value: yup.string().required(() => t`Выберите тип спорта`),
        })
        .nullable()
        .required(() => t`Выберите тип спорта`) as yup.AnyObjectSchema,
      email: yup
        .string()
        .trim()
        .nullable()
        .notRequired()
        .test(
          'is-email',
          () => t`Некорректный email`,
          (val) => !val || yup.string().email().isValidSync(val),
        ),
      phone: yup
        .string()
        .trim()
        .nullable()
        .notRequired()
        .test(
          'is-phone',
          () => t`Некорректный номер телефона`,
          (val) => !val || validPhoneRegex.test(val),
        ),
      address: yup.mixed().nullable().notRequired(),
      timezone: yup
        .object({
          label: yup.string().required(),
          value: yup.string().required(() => t`Выберите часовой пояс`),
        })
        .nullable()
        .required(() => t`Выберите часовой пояс`) as yup.AnyObjectSchema,
      description: yup.string().nullable().notRequired(),
      logo: yup.array().nullable().notRequired(),
    })
    .required();

export default organizerFormValidator;
